import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import SideSearchbar from '../../components/SideSearchbar/'
import { GetCountries, EditCountry, CreateCountry, DeleteCountry } from './LandActions'
import { Container, DialogContentText, DialogContent, DialogTitle, DialogActions, Dialog, Grid, Button, TextField } from '@material-ui/core';
import OverLoader from '../../components/common/loader';
import '../../App.css'
import isEmpty from 'lodash.isempty';
import { LogoutAction } from '../../actions';
import { Prompt } from "react-router-dom";

class Land extends Component {

  constructor(props) {
    super(props);
    this.state = {
      listData: [],
      landField: '',
      landID: '',
      editMode: false,
      newLand: '',
      editedLand: '',
      deleteLand: '',
      landError: false,
      errorMessage: '',
      isBlocking: false,
      isDeleteContactDialogOpen: false,
      accessErrorDialog: false
    }

    this.baseState = this.state;
    this.textInput = React.createRef();

  }

  focusTextInput = () => {
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')
    if (Number(access_rights.countries) === 2 && token !== null)
      this.textInput.current.focus();
  }

  componentDidMount = () => {
    const { GetCountries } = this.props
    GetCountries()
  }
  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { lands_list, new_land, edited_land, delete_success, error_validation, access_error, message_valid } = this.props
    const { landID } = this.state
    if (nextProps.lands_list !== lands_list) {
      this.setState({ listData: nextProps.lands_list })
    }
    else if (nextProps.new_land !== new_land) {
      this.setState({ newLand: nextProps.new_land, isBlocking: false, landID: nextProps.new_land.id, editMode: true })
    }
    else if (nextProps.error_validation !== error_validation || nextProps.message_valid !== message_valid) {
      this.setState({ errorMessage: nextProps.error_validation, landError: true, isDeleteContactDialogOpen: false })
    }
    else if (nextProps.edited_land !== edited_land) {
      this.setState({ editedLand: nextProps.edited_land, isBlocking: false, })
    }
    else if (nextProps.delete_success !== delete_success) {
      this.setState({ deleteLand: landID, landField: '', isBlocking: false, editMode: false, isDeleteContactDialogOpen: false })
    }
    else if (nextProps.access_error !== access_error) {
      this.setState({ accessErrorDialog: true })
    }

  }

  getCountryData = (item) => {
    const { isBlocking } = this.state
    if (!isBlocking) {
      this.setState({ landID: item.id, landError: false, isBlocking: false, landField: item.name, editMode: true })
      setTimeout(() => {
        this.focusTextInput()
      }, 300)
    } else {
      let retVal = window.confirm("Ihre Änderungen wurden nicht gepeichert. Möchten Sie trotzdem fortfahren?");

      if (retVal === true) {
        this.setState({ isBlocking: false }, () => this.getCountryData(item))
      } else {
        this.setState({ isBlocking: false }, () => setTimeout(() => {
          this.setState({ isBlocking: true })
        }, 1000))
      }
    }
  }

  editCountryData = () => {
    const { landID, landField } = this.state
    const { EditCountry } = this.props
    if (landField !== '') {
      EditCountry(landID, landField)
    }
  }

  creetCountry = () => {
    const { CreateCountry } = this.props
    const { landField } = this.state
    if (landField !== '') {
      CreateCountry(landField)
    }
  }

  openDeleteDialog = () => {
    this.setState({ isDeleteContactDialogOpen: true })
  }
  closeDeleteContactDialog = () => {
    this.setState({ isDeleteContactDialogOpen: false })

  }

  deleteLand = () => {
    const { DeleteCountry } = this.props
    const { landID } = this.state
    DeleteCountry(landID)
    setTimeout(() => {
      this.focusTextInput()
    }, 100)
  }

  resetForm = () => {
    this.setState({ landField: '', landError: false, isBlocking: false, landID: '', editMode: false })
    setTimeout(() => {
      this.focusTextInput()
    }, 200)
  }

  render() {
    const { landError, accessErrorDialog, isBlocking, errorMessage, deleteLand, isDeleteContactDialogOpen, editMode, listData, landField, newLand, editedLand } = this.state
    const { isloading, access_error } = this.props
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')
    if (token === null) {
      this.props.LogoutAction()
    }
    return (
      <div>
        {isloading && <OverLoader />}
        <Container maxWidth="xl">
          <Grid container spacing={3} className="mainBlock">
            {isEmpty(errorMessage.message) ?
              <Fragment>
                <Grid item md={3} sm={4} xs={12}>
                  <div className="leftSide">
                    <SideSearchbar
                      tittle={"Neues Land"}
                      listData={listData}
                      newList={newLand}
                      editedList={editedLand}
                      deleteList={deleteLand}
                      getDataOfSelectedItemFunc={this.getCountryData}
                      createNewListFunc={this.resetForm}
                      isRight={Number(access_rights.countries)}
                    />
                  </div>
                </Grid>
                <Grid item md={9} sm={8} xs={12}
                  className={`${Number(access_rights.countries) === 1 ? "disableALlFields" : ""}`}
                >
                  <Prompt
                    when={isBlocking}
                    message={location =>
                      `Ihre Änderungen wurden nicht gepeichert. Möchten Sie trotzdem fortfahren? `
                    }
                  />
                  <div className="rightBlock liproCard">
                    <div className="mb2">
                      <label className="mb1">Land</label>
                      <TextField
                        inputProps={{
                          maxLength: 40
                        }}
                        helperText={landError ? errorMessage.base ? errorMessage.base[0] : errorMessage.country : ''}
                        error={landError ? true : false}
                        inputRef={this.textInput} size="small" value={landField} className="innerInput"
                        onChange={(e) => this.setState({ landField: e.target.value, isBlocking: true, landError: false })} variant="outlined" />
                    </div>
                    {Number(access_rights.countries) !== 1 &&
                      <div className="actionBtn">

                        {editMode ?
                          <Button variant="outlined" color="primary" onClick={() => { this.editCountryData() }} >Speichern</Button>
                          :
                          <Button variant="outlined" color="primary" onClick={() => { this.creetCountry() }} >Hinzufügen</Button>
                        }
                        {editMode &&
                          <Button variant="outlined" color="primary" onClick={() => { this.openDeleteDialog() }} >Löschen</Button>
                        }
                      </div>
                    }
                    <Dialog
                      open={isDeleteContactDialogOpen}
                    >
                      <DialogTitle>Land löschen</DialogTitle>
                      <DialogContent>
                        <DialogContentText >
                          Sind Sie sicher?
              </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={this.deleteLand} size="small" variant="outlined" color="primary" autoFocus>
                          Bestätigen
              </Button>
                        <Button onClick={this.closeDeleteContactDialog} size="small" variant="outlined" color="secondary">
                          Abbrechen
              </Button>
                      </DialogActions>
                    </Dialog>

                    <Dialog
                      open={accessErrorDialog}
                    >
                      <DialogTitle>Länder</DialogTitle>
                      <DialogContent>
                        <DialogContentText >
                          {access_error && access_error.message}
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={() => this.setState({ accessErrorDialog: false })} size="small" variant="outlined" color="secondary" >
                          Abbrechen
              </Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                </Grid>
              </Fragment>
              :
              <Grid item md={12} sm={12} xs={12}>
                <div className="rightBlock rightBlock-bgWhite user-system">
                  <h3>{errorMessage.message}</h3>
                </div>
              </Grid>
            }
          </Grid>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = ({ land }) => {
  return {
    isloading: land.loading,
    lands_list: land.lands_list,
    message_valid: land.message_valid,
    new_land: land.new_land,
    edited_land: land.edited_land,
    error_validation: land.error_message,
    delete_success: land.success,
    access_error: land.access_error,

  }
};

const mapDispatchToProps = dispatch => {
  return {
    // dispatching actions
    GetCountries: () => dispatch(GetCountries()),
    EditCountry: (id, name) => dispatch(EditCountry(id, name)),
    CreateCountry: (id, name) => dispatch(CreateCountry(id, name)),
    DeleteCountry: (id) => dispatch(DeleteCountry(id)),
    LogoutAction: () => dispatch(LogoutAction()),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Land)